import styled from 'styled-components';

import { IOcAppTheme } from '../../config/ocTheme';

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.color.betaBadgeBG};
  color: ${({ theme }) => (theme as IOcAppTheme).color.sourcesText};
  font-size: ${({ theme }) => (theme as IOcAppTheme).font.size.small};
`;

export const IconSvg = styled.svg<{ $color: string }>`
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  color: ${({ $color }) => $color};
`;

